const customStyles = {
  headRow: {
    style: {
      border: "none",
      backgroundColor: "#F5F5F5",
    },
  },
  headCells: {
    style: {
      color: "#202124",
      fontSize: "16px",
      whiteSpace: "unset !important",
      textOverflow: "unset",
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: "rgb(230, 244, 244)",
      borderBottomColor: "#FFFFFF",
      borderRadius: "25px",
      outline: "1px solid #FFFFFF",
      whiteSpace: "unset",
      textOverflow: "unset",
    },
  },
  pagination: {
    style: {
      border: "none",
    },
  },
};

export { customStyles };
